import './PanelTabs.css'

/**
 * ActionsTab - Displays prioritized action items from analysis.
 *
 * Props:
 *   actions: array of { title, detail, tags: [{label, color}], hours, done }
 *   onUpdate: function(newActions) - callback when actions change
 */
export default function ActionsTab({ actions = [], onUpdate }) {

  const toggleAction = (index) => {
    if (!onUpdate) return
    const updated = actions.map((a, i) =>
      i === index ? { ...a, done: !a.done } : a
    )
    onUpdate(updated)
  }

  if (actions.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '40px 20px', color: 'var(--gray-400)' }}>
        <div style={{ fontSize: 24, marginBottom: 8 }}>📋</div>
        <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 4 }}>No actions yet</div>
        <div style={{ fontSize: 12 }}>
          Actions are generated from analysis findings.
        </div>
      </div>
    )
  }

  const totalHours = actions.reduce((sum, a) => {
    const match = a.hours?.match(/\d+/)
    return sum + (match ? parseInt(match[0]) : 0)
  }, 0)

  const doneCount = actions.filter(a => a.done).length

  return (
    <div>
      <div style={{ fontSize: 12, color: 'var(--gray-500)', marginBottom: 14 }}>
        {actions.length} actions · ~{totalHours} hours estimated · {doneCount} completed
        {' · '}
        <a href="#" style={{ color: 'var(--green-dark)', fontWeight: 600, textDecoration: 'none' }}>
          Generate Workplan →
        </a>
      </div>

      {actions.map((action, i) => (
        <div key={i} className="action-item">
          <div
            className={`action-check ${action.done ? 'checked' : ''}`}
            onClick={() => toggleAction(i)}
          >
            {action.done && '✓'}
          </div>
          <div className="action-info">
            <div
              className="action-title"
              style={action.done ? { textDecoration: 'line-through', color: 'var(--gray-400)' } : undefined}
            >
              {action.title}
            </div>
            <div
              className="action-detail"
              style={action.done ? { color: 'var(--gray-400)' } : undefined}
            >
              {action.detail}
            </div>
            {action.tags && action.tags.length > 0 && (
              <div className="action-tags">
                {action.tags.map((tag, j) => (
                  <span
                    key={j}
                    className="action-tag"
                    style={
                      tag.color === 'red' ? { background: 'var(--red-light)', color: 'var(--red)' } :
                      tag.color === 'amber' ? { background: 'var(--amber-light)', color: 'var(--amber)' } :
                      undefined
                    }
                  >
                    {tag.label}
                  </span>
                ))}
              </div>
            )}
          </div>
          <div
            className="action-estimate"
            style={action.done ? { color: 'var(--green-dark)' } : undefined}
          >
            {action.hours}
          </div>
        </div>
      ))}
    </div>
  )
}
